// import { useState } from "react";
// import {
//   getStorage,
//   ref,
//   uploadBytesResumable,
//   getDownloadURL,
// } from "firebase/storage";
// import { v4 as uuidv4 } from "uuid";
// import { auth, db } from "../../firebase";
// import {
//   doc,
//   setDoc,
//   addDoc,
//   collection,
//   serverTimestamp,
// } from "firebase/firestore";

// import css from "../admin/adm.module.css";
// export default function AddBlog() {
//   const objList = [
//     {
//       name: "Заголовок",
//       transliter: "zag",
//     },
//     {
//       name: "Перший опис",
//       transliter: "chortDesc",
//     },
//     {
//       name: "Другий опис",
//       transliter: "centrDesc",
//     },
//     {
//       name: "Третій",
//       transliter: "longDesc",
//     },
//     {
//       name: "ID відео",
//       transliter: "videoId",
//     },
//   ];

//   const [formData, setFormData] = useState({});
//   const [file, setFile] = useState(null);

//   const handleFormSubmit = async (event) => {
//     event.preventDefault();

//     const form = event.target;
//     const formDataValue = new FormData(form);
//     const formDataObj = Object.fromEntries(formDataValue.entries());
//     setFormData(formDataObj);

//     console.log("formData", formDataObj);

//     if (file) {
//       try {
//         const newObj = { ...formDataObj };
//         const storage = getStorage();
//         const storageRef = ref(storage, `blog/${uuidv4()}/${file.name}`);
//         const uploadTask = uploadBytesResumable(storageRef, file);

//         uploadTask.on(
//           "state_changed",
//           (snapshot) => {
//             const progress =
//               (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
//             console.log("Upload progress:", progress);
//           },
//           (error) => {
//             console.error("Error uploading file:", error);
//           }
//         );

//         await uploadTask;

//         const downloadURL = await getDownloadURL(storageRef);
//         newObj.photo = downloadURL;
//         newObj.uid = uuidv4();
//         newObj.timestamp = serverTimestamp();
//         await addDoc(collection(db, "blog"), newObj);

//         console.log("Стаття успішно додана до Firestore:", newObj);
//       } catch (error) {
//         console.error("Помилка під час додавання статті:", error);
//       }
//     } else {
//       console.log("Фото не вибрано");
//     }
//   };

//   const handleFileChange = (event) => {
//     const selectedFile = event.target.files[0];
//     setFile(selectedFile);
//   };

//   return (
//     <div className={css.blogWrap}>
//       <form onSubmit={handleFormSubmit}>
//         {objList.map((el, index) => (
//           <div key={index} className={css.wrapSmallList}>
//             <p className={css.paramBooks}>{el.name}</p>
//             <input type="text" name={el.transliter} id="nameProp" />
//           </div>
//         ))}

//         <div className={css.wrapSmallList}>
//           <p className={css.paramBooks}>Фото</p>
//           <input type="file" name="photo" onChange={handleFileChange} />
//         </div>

//         <button className={css.addBookButtonBlog} type="submit">
//           Додати статтю
//         </button>
//       </form>
//     </div>
//   );
// }
import { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import {
  addDoc,
  collection,
  serverTimestamp,
  getDocs,
} from "firebase/firestore";
import {
  createBlogSlug,
  normalizeBlogSlug,
  getBlogSlug,
  getUniqueBlogSlug,
} from "../../function/blogSlug";
import { db } from "../../firebase";
import css from "../admin/adm.module.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function AddBlog() {
  const objList = [
    { name: "Заголовок", transliter: "zag" },
    {
      name: "ЧПУ URL",
      transliter: "slug",
    },
    { name: "Перший опис", transliter: "chortDesc" },
    { name: "ID відео", transliter: "videoId" },
    { name: "SEO title", transliter: "seoTitle" },
    { name: "SEO description", transliter: "seoDescription" },
  ];

  const [file, setFile] = useState(null);
  const [longDesc, setLongDesc] = useState("");
  const [check, setCheck] = useState(false); // 🔧 чекбокс
  const [linkto, setLinkto] = useState(""); // 🔧 новий інпут

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    const form = event.target;
    const formDataValue = new FormData(form);
    const formDataObj = Object.fromEntries(formDataValue.entries());

    formDataObj.longDesc = longDesc;
    formDataObj.check = check;

    /*
     * Перевіряємо заголовок.
     */
    const articleTitle = String(formDataObj.zag || "").trim();

    if (!articleTitle) {
      window.alert("Вкажіть заголовок статті");
      return;
    }

    /*
     * Отримуємо значення ЧПУ з форми.
     */
    const enteredSlug = String(formDataObj.slug || "").trim();

    /*
     * Нормалізуємо вручну введене ЧПУ.
     */
    const manualSlug = normalizeBlogSlug(enteredSlug);

    /*
     * Створюємо автоматичне ЧПУ із заголовка.
     */
    const generatedSlug = createBlogSlug(articleTitle);

    /*
     * Якщо користувач щось ввів у поле ЧПУ,
     * але після очищення нічого не залишилося.
     *
     * Наприклад, було введено лише:
     * !!!///
     */
    if (enteredSlug && !manualSlug) {
      window.alert(
        "Введено некоректне ЧПУ. Використовуйте слова, цифри та дефіси.",
      );

      return;
    }

    if (!manualSlug && !generatedSlug) {
      window.alert("Не вдалося сформувати ЧПУ із заголовка статті.");

      return;
    }

    /*
     * Перевіряємо зовнішнє посилання.
     */
    if (check && linkto.trim()) {
      formDataObj.linkto = linkto.trim();
    }

    /*
     * Фото у вашій формі обов'язкове.
     */
    if (!file) {
      window.alert("Виберіть фото статті");
      return;
    }

    try {
      /*
       * Отримуємо всі наявні статті.
       */
      const articlesSnapshot = await getDocs(collection(db, "blog"));

      /*
       * Створюємо список усіх зайнятих ЧПУ.
       *
       * getBlogSlug також врахує старі статті,
       * у яких поля slug ще немає.
       */
      const usedSlugs = new Set(
        articlesSnapshot.docs
          .map((documentItem) => {
            return getBlogSlug({
              id: documentItem.id,
              ...documentItem.data(),
            });
          })
          .filter(Boolean),
      );

      let finalSlug = "";

      /*
       * Якщо ЧПУ введено вручну,
       * воно повинно бути унікальним.
       */
      if (manualSlug) {
        if (usedSlugs.has(manualSlug)) {
          window.alert(
            `ЧПУ "${manualSlug}" уже використовується іншою статтею.`,
          );

          return;
        }

        finalSlug = manualSlug;
      } else {
        /*
         * Якщо поле порожнє,
         * створюємо ЧПУ із заголовка.
         *
         * Якщо адреса зайнята:
         * nazva-statti-2
         * nazva-statti-3
         */
        finalSlug = getUniqueBlogSlug(generatedSlug, usedSlugs);
      }

      /*
       * Створюємо uid один раз.
       *
       * Він залишається в базі для сумісності
       * зі старими адресами.
       */
      const articleUid = uuidv4();

      const storage = getStorage();

      const storageRef = ref(storage, `blog/${articleUid}/${file.name}`);

      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

          console.log("Upload progress:", progress);
        },
        (uploadError) => {
          console.error("Помилка завантаження фото:", uploadError);
        },
      );

      await uploadTask;

      const downloadURL = await getDownloadURL(storageRef);

      const newArticle = {
        ...formDataObj,
        zag: articleTitle,
        slug: finalSlug,
        photo: downloadURL,
        uid: articleUid,
        timestamp: serverTimestamp(),
      };

      await addDoc(collection(db, "blog"), newArticle);

      window.alert(`Статтю успішно додано.\nURL: /blog/${finalSlug}`);

      /*
       * Очищення форми після додавання.
       */
      form.reset();

      setLongDesc("");
      setFile(null);
      setCheck(false);
      setLinkto("");
    } catch (error) {
      console.error("Помилка при додаванні статті:", error);

      window.alert("Не вдалося додати статтю. Перевірте консоль.");
    }
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  return (
    <div className={css.blogWrapnewBlog}>
      <form onSubmit={handleFormSubmit}>
        {objList.map((el, index) => (
          <div key={index} className={css.wrapSmallListnewBlog}>
            <p className={css.paramBooksnewBlog}>{el.name}</p>
            <input
              type="text"
              name={el.transliter}
              className={css.inputnewBlog}
              placeholder={
                el.transliter === "slug" ? "Наприклад: yak-vybraty-knyhu" : ""
              }
            />
          </div>
        ))}

        <div className={css.wrapSmallListnewBlog}>
          <p className={css.paramBooksnewBlog}>Третій (довгий опис)</p>
          <ReactQuill
            value={longDesc}
            onChange={setLongDesc}
            className={css.quillEditornewBlog}
            modules={{
              toolbar: [
                [{ header: [1, 2, 3, false] }],
                ["bold", "italic", "underline", "strike", "link"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ align: [] }],
                ["clean"],
              ],
            }}
            formats={[
              "header",
              "bold",
              "italic",
              "underline",
              "strike",
              "link",
              "list",
              "bullet",
              "align",
            ]}
          />
        </div>

        <div className={css.wrapSmallListnewBlog}>
          <p className={css.paramBooksnewBlog}>Фото</p>
          <input
            type="file"
            name="photo"
            onChange={handleFileChange}
            className={css.inputnewBlog}
          />
        </div>

        <div className={css.wrapSmallListnewBlog}>
          <label className={css.paramBooksnewBlog}>
            <input
              type="checkbox"
              checked={check}
              onChange={(e) => setCheck(e.target.checked)}
            />
            &nbsp;Посилання на сторонній сайт
          </label>
        </div>

        {check && (
          <div className={css.wrapSmallListnewBlog}>
            <p className={css.paramBooksnewBlog}>Посилання</p>
            <input
              type="text"
              value={linkto}
              onChange={(e) => setLinkto(e.target.value)}
              className={css.inputnewBlog}
              placeholder="https://example.com"
            />
          </div>
        )}

        <button className={css.addBookButtonBlognewBlog} type="submit">
          Додати статтю
        </button>
      </form>
    </div>
  );
}
